import React from 'react';
import SupplierLayout from '../../layouts/SupplierLayout';
import AllItems from '../../components/Tables/AllItems';

const ItemPage = () => {
	return (
		<SupplierLayout>
			<AllItems />
		</SupplierLayout>
	);
};
export default ItemPage;
